// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-actvity-accident-js": () => import("./../../../src/pages/actvity-accident.js" /* webpackChunkName: "component---src-pages-actvity-accident-js" */),
  "component---src-pages-ad-apply-js": () => import("./../../../src/pages/ad-apply.js" /* webpackChunkName: "component---src-pages-ad-apply-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-productdetail-js": () => import("./../../../src/pages/productdetail.js" /* webpackChunkName: "component---src-pages-productdetail-js" */)
}

